import { CS } from "../../../base/utils/styler"

export const baseStyle: CS = {
    margin: '20px 0',
    height: '30px',
    transition: 'width 0.3s ease',
    opacity: '0'
}

export const placeholderStyle: CS = {
    background: '#f1f1f1',
    borderRadius: '5px',
    overflow: 'hidden',
    height: '10px',
    position: 'relative',
}

export const fillStyle: CS = {
    background: 'linear-gradient(90deg, #667eea, #764ba2)',
    height: '10px',
    transition: 'width 0.3s ease',
    position: 'absolute',
    top: '0',
    left: '0',
}

export const textStyle: CS = {
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
    marginTop: '5px',
}